function initPhotoSwipe() {
	this.classNameCSS = '.gallery-ps';
	if ($(this.classNameCSS).length)
		this.init(this.classNameCSS);
}

initPhotoSwipe.prototype.getItems = function() {
	var self = this,
		el = $(this.classNameCSS),
		items = [];

	if ($(this.classNameCSS).length) {
		$.each(el, function(i, gallery) {
			var item,
				dataSize = el.attr('data-size') ? el.attr('data-size') : "1920x1080",
				title = el.attr('data-title') ? el.attr('data-title') : "",
				size = dataSize.split('x'),
				childElements,
				thumbnailEl,
				gid = i,
				iIndex = 0;

			$(gallery).attr('data-gid',gid);

			items.push([]);

			$.each($(gallery).find("a.item-ps"),function(i,v) {
				if (!$(v).closest('.slick-slide').hasClass('slick-cloned')) {
					var src = $(v).attr("href");
					$(v).attr('data-pid',iIndex);
					var msrc = $(v).attr('data-msrc');
					if ($(v).attr('data-size') !== undefined) {
						mySize = $(v).attr('data-size').split('x');
					}
					else {
						mySize = size;
					}
					item = {
						src: src,
						msrc: msrc,
						el: $(v).find('img')[0],
						w: parseInt(mySize[0], 10),
						h: parseInt(mySize[1], 10),
					};
					var mediumSrc = $(v).attr('data-med');
		          	if(mediumSrc) {
		            	var medSize = $(v).attr('data-med-size').split('x');
		            	// "medium-sized" image
		            	item.m = {
		              		src: mediumSrc,
		              		w: parseInt(medSize[0], 10),
		              		h: parseInt(medSize[1], 10)
		            	};
		          	}
					// original image
		          	item.o = {
		          		src: item.src,
		          		w: item.w,
		          		h: item.h
		          	};
					items[gid].push(item);
					iIndex++;
				}
			});
		});
	}
	this.items = items;
};

initPhotoSwipe.prototype.init = function(gallerySelector) {

	var self = this;
	pswpElement ='';
	var markup = '<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">';
	markup += '<div class="pswp__bg"></div>';
	markup += '<div class="pswp__scroll-wrap">';
	markup += '<div class="pswp__container">';
	markup += '<div class="pswp__item"></div>';
	markup += '<div class="pswp__item"></div>';
	markup += '<div class="pswp__item"></div>';
	markup += '</div>';
	markup += '<div class="pswp__ui pswp__ui--hidden">';
	markup += '<div class="download-file-icon -hidden">';
	markup += '<a href="#" target="_blank">';
	markup += '<svg version="1.1" class="large" id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100.1 100.2" style="enable-background:new 0 0 100.1 100.2;" xml:space="preserve"><g id="Group_13064" transform="translate(-1023.852 -1222.537)"><g class="st0" enable-background="new"><path fill="#D3373C" d="M1040.9,1241.1L1040.9,1241.1c0.4-0.6,1.1-0.8,1.7-0.8c1.7,0,2.8,1.4,2.8,3c0,1.6-1.2,3-2.8,3c-0.6,0-1.3-0.2-1.7-0.7v3.4h-2v-8.5h2V1241.1z M1040.8,1243.3c0,0.7,0.5,1.3,1.3,1.3c0.8,0,1.3-0.6,1.3-1.3c0-0.7-0.5-1.3-1.3-1.3C1041.3,1242,1040.8,1242.6,1040.8,1243.3z"/><path fill="#D3373C" d="M1053,1243.3c0,1.9-1.6,3-3.4,3c-1.8,0-3.4-1.1-3.4-3s1.6-3,3.4-3C1051.4,1240.3,1053,1241.3,1053,1243.3zM1048.3,1243.3c0,0.7,0.5,1.3,1.3,1.3s1.3-0.6,1.3-1.3c0-0.7-0.5-1.3-1.3-1.3S1048.3,1242.6,1048.3,1243.3z"/><path fill="#D3373C" d="M1054,1237h2v4c0.4-0.5,1.1-0.7,1.7-0.7c1.7,0,2.8,1.4,2.8,3c0,1.6-1.2,3-2.8,3c-0.7,0-1.3-0.3-1.7-0.8h0v0.6h-2V1237z M1055.9,1243.3c0,0.7,0.5,1.3,1.3,1.3c0.8,0,1.3-0.6,1.3-1.3c0-0.7-0.5-1.3-1.3-1.3C1056.4,1242,1055.9,1242.6,1055.9,1243.3z"/><path fill="#D3373C" d="M1063.8,1238.3c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1S1063.8,1237.7,1063.8,1238.3zM1063.7,1246.1h-2v-5.6h2V1246.1z"/><path fill="#D3373C" d="M1070.9,1243.6h-4.2c0,0.8,0.4,1.3,1.3,1.3c0.4,0,0.7-0.1,1-0.5h1.9c-0.2,0.7-0.5,1.1-1.1,1.5s-1.2,0.5-1.8,0.5c-1.9,0-3.3-1.1-3.3-3c0-1.9,1.3-3,3.1-3c2,0,3.1,1.2,3.1,3.1V1243.6z M1069.1,1242.4c-0.1-0.5-0.6-0.9-1.1-0.9c-0.6,0-1.1,0.3-1.2,0.9H1069.1z"/><path fill="#D3373C" d="M1074,1241.4L1074,1241.4c0.4-0.7,1.1-1,1.8-1h0.4v1.9c-0.3-0.2-0.5-0.2-0.8-0.2c-1.1,0-1.4,0.7-1.4,1.7v2.3h-2v-5.6h2V1241.4z"/><path fill="#D3373C" d="M1082.3,1244.4v1.7h-5.7l2.7-4h-2.3v-1.7h5.6l-2.6,4H1082.3z"/><path fill="#D3373C" d="M1089.3,1241.1L1089.3,1241.1c0.4-0.6,1.1-0.8,1.7-0.8c1.7,0,2.8,1.4,2.8,3c0,1.6-1.2,3-2.8,3c-0.6,0-1.3-0.2-1.7-0.7v3.4h-2v-8.5h2V1241.1z M1089.2,1243.3c0,0.7,0.5,1.3,1.3,1.3c0.8,0,1.3-0.6,1.3-1.3c0-0.7-0.5-1.3-1.3-1.3C1089.7,1242,1089.2,1242.6,1089.2,1243.3z"/><path fill="#D3373C" d="M1097,1246.1h-2v-9.1h2V1246.1z"/><path fill="#D3373C" d="M1100.6,1238.3c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1S1100.6,1237.7,1100.6,1238.3zM1100.4,1246.1h-2v-5.6h2V1246.1z"/><path fill="#D3373C" d="M1103.9,1242.5l2.1-2h2.7l-2.8,2.6l3,3h-2.8l-2.2-2.3v2.3h-2v-9.1h2V1242.5z"/></g><g class="st0" enable-background="new"><path fill="#D3373C" d="M1051.5,1259.5L1051.5,1259.5c-0.4,0.6-1.1,0.8-1.7,0.8c-1.7,0-2.8-1.4-2.8-3s1.2-3,2.8-3c0.6,0,1.3,0.2,1.7,0.7v-4h2v9.1h-2V1259.5z M1049,1257.3c0,0.7,0.5,1.3,1.3,1.3s1.3-0.6,1.3-1.3c0-0.7-0.5-1.3-1.3-1.3S1049,1256.6,1049,1257.3z"/><path fill="#D3373C" d="M1061.3,1257.3c0,1.9-1.6,3-3.4,3c-1.8,0-3.4-1.1-3.4-3s1.6-3,3.4-3C1059.7,1254.3,1061.3,1255.3,1061.3,1257.3z M1056.6,1257.3c0,0.7,0.5,1.3,1.3,1.3s1.3-0.6,1.3-1.3c0-0.7-0.5-1.3-1.3-1.3S1056.6,1256.6,1056.6,1257.3z"/><path fill="#D3373C" d="M1070.5,1259.5L1070.5,1259.5c-0.4,0.6-1.1,0.8-1.7,0.8c-1.7,0-2.8-1.4-2.8-3s1.2-3,2.8-3c0.6,0,1.3,0.2,1.7,0.7v-4h2v9.1h-2V1259.5z M1068,1257.3c0,0.7,0.5,1.3,1.3,1.3s1.3-0.6,1.3-1.3c0-0.7-0.5-1.3-1.3-1.3S1068,1256.6,1068,1257.3z"/><path fill="#D3373C" d="M1075.9,1255.4L1075.9,1255.4c0.4-0.7,1.1-1,1.8-1h0.4v1.9c-0.3-0.2-0.5-0.2-0.8-0.2c-1.1,0-1.4,0.7-1.4,1.7v2.3h-2v-5.6h2V1255.4z"/><path fill="#D3373C" d="M1081,1254.4v3c0,0.7,0.2,1.2,1,1.2s1-0.5,1-1.2v-3h2v3.4c0,1.9-1.3,2.4-3,2.4s-3-0.6-3-2.4v-3.4H1081z"/><path fill="#D3373C" d="M1088.4,1256.5l2.1-2h2.7l-2.8,2.6l3,3h-2.8l-2.2-2.3v2.3h-2v-9.1h2V1256.5z"/><path fill="#D3373C" d="M1095.9,1254.4v3c0,0.7,0.2,1.2,1,1.2s1-0.5,1-1.2v-3h2v3.4c0,1.9-1.3,2.4-3,2.4c-1.7,0-3-0.6-3-2.4v-3.4H1095.9z"/></g><g id="Path_6630" transform="translate(1023.852 1222.537)"><path fill="none" d="M0.1,0.2h100v100H0.1V0.2z"/><path fill="#D3373C" d="M3.1,3.2l0,94h94l0-94H3.1 M0.1,0.2h100l0,100H0.1L0.1,0.2z"/></g><g id="Group_12887" transform="translate(1063.309 1272.537)"><rect id="Rectangle_889" x="0.1" y="37.6" fill="#D3373C" width="21.2" height="2"/><path id="Path_6633" fill="#D3373C" d="M14.6,0.3H0.1v26.2h8.3v-2H2.1V2.3h11.1v6.1h6.1v16.1h-6.3v2h8.3V6.8L14.6,0.3z M15.2,3.7 l2.7,2.6h-2.7L15.2,3.7z"/><path id="Path_6634" fill="#D3373C" d="M9.7,16.5v16.4l-4.4-4l-1.4,1.5l6.7,6.3l6.7-6.3L16,28.8l-4.4,4V16.5H9.7z"/></g></g></svg>';
	markup += '<svg version="1.1" class="small" id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 186.4 48.6" style="enable-background:new 0 0 186.4 48.6;" xml:space="preserve"><g id="Path_6630" transform="translate(186.421 0) rotate(90)"><path fill="#FFFFFF" d="M47.1,184.9H1.5l0-183.4h45.6L47.1,184.9z"/><path fill="#D3373C" d="M3,3l0,180.4h42.6V3H3 M0,0h48.6v186.4H0L0,0z"/></g><g class="st2" enable-background="new"><path fill="#D3373C" d="M14,19.8h3.3c1.8,0,3,0.8,3,2.7c0,2-1.1,2.8-2.9,2.8h-1.2v2.8H14V19.8z M16.1,23.6h0.4c0.8,0,1.6,0,1.6-1c0-1-0.7-1.1-1.6-1.1h-0.4V23.6z"/><path fill="#D3373C" d="M27.5,25.3c0,1.9-1.6,3-3.4,3c-1.8,0-3.4-1.1-3.4-3s1.6-3,3.4-3C25.9,22.3,27.5,23.4,27.5,25.3z M22.8,25.3c0,0.7,0.5,1.3,1.3,1.3s1.3-0.6,1.3-1.3c0-0.7-0.5-1.3-1.3-1.3S22.8,24.6,22.8,25.3z"/><path fill="#D3373C" d="M28.5,19h2v4c0.4-0.5,1.1-0.7,1.7-0.7c1.7,0,2.8,1.4,2.8,3c0,1.6-1.2,3-2.8,3c-0.7,0-1.3-0.3-1.7-0.8h0v0.6h-2V19z M30.4,25.3c0,0.7,0.5,1.3,1.3,1.3c0.8,0,1.3-0.6,1.3-1.3c0-0.7-0.5-1.3-1.3-1.3C30.9,24,30.4,24.6,30.4,25.3z"/><path fill="#D3373C" d="M38.3,20.3c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1S38.3,19.7,38.3,20.3z M38.2,28.1h-2v-5.6h2V28.1z"/><path fill="#D3373C" d="M45.5,25.6h-4.2c0,0.8,0.4,1.3,1.3,1.3c0.4,0,0.7-0.1,1-0.5h1.9c-0.2,0.7-0.5,1.1-1.1,1.5s-1.2,0.5-1.8,0.5c-1.9,0-3.3-1.1-3.3-3c0-1.9,1.3-3,3.1-3c2,0,3.1,1.2,3.1,3.1V25.6z M43.6,24.5c-0.1-0.5-0.6-0.9-1.1-0.9c-0.6,0-1.1,0.3-1.2,0.9H43.6z"/><path fill="#D3373C" d="M48.5,23.4L48.5,23.4c0.4-0.7,1.1-1,1.8-1h0.4v1.9c-0.3-0.2-0.5-0.2-0.8-0.2c-1.1,0-1.4,0.7-1.4,1.7v2.3h-2v-5.6h2V23.4z"/><path fill="#D3373C" d="M56.8,26.5v1.7h-5.7l2.7-4h-2.3v-1.7h5.6l-2.6,4H56.8z"/><path fill="#D3373C" d="M63.8,23.1L63.8,23.1c0.4-0.6,1.1-0.8,1.7-0.8c1.7,0,2.8,1.4,2.8,3c0,1.6-1.2,3-2.8,3c-0.6,0-1.3-0.2-1.7-0.7v3.4h-2v-8.5h2V23.1z M63.7,25.3c0,0.7,0.5,1.3,1.3,1.3c0.8,0,1.3-0.6,1.3-1.3c0-0.7-0.5-1.3-1.3-1.3C64.2,24,63.7,24.6,63.7,25.3z"/><path fill="#D3373C" d="M71.5,28.1h-2V19h2V28.1z"/><path fill="#D3373C" d="M75.1,20.3c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1S75.1,19.7,75.1,20.3z M75,28.1h-2v-5.6h2V28.1z"/><path fill="#D3373C" d="M78.4,24.5l2.1-2h2.7l-2.8,2.6l3,3h-2.8l-2.2-2.3v2.3h-2V19h2V24.5z"/><path fill="#D3373C" d="M92.3,27.5L92.3,27.5c-0.4,0.6-1.1,0.8-1.7,0.8c-1.7,0-2.8-1.4-2.8-3s1.2-3,2.8-3c0.6,0,1.3,0.2,1.7,0.7v-4h2v9.1h-2V27.5z M89.8,25.3c0,0.7,0.5,1.3,1.3,1.3s1.3-0.6,1.3-1.3c0-0.7-0.5-1.3-1.3-1.3S89.8,24.6,89.8,25.3z"/><path fill="#D3373C" d="M102.1,25.3c0,1.9-1.6,3-3.4,3c-1.8,0-3.4-1.1-3.4-3s1.6-3,3.4-3S102.1,23.4,102.1,25.3z M97.4,25.3c0,0.7,0.5,1.3,1.3,1.3s1.3-0.6,1.3-1.3c0-0.7-0.5-1.3-1.3-1.3S97.4,24.6,97.4,25.3z"/><path fill="#D3373C" d="M111.3,27.5L111.3,27.5c-0.4,0.6-1.1,0.8-1.7,0.8c-1.7,0-2.8-1.4-2.8-3s1.2-3,2.8-3c0.6,0,1.3,0.2,1.7,0.7v-4h2v9.1h-2V27.5z M108.8,25.3c0,0.7,0.5,1.3,1.3,1.3s1.3-0.6,1.3-1.3c0-0.7-0.5-1.3-1.3-1.3S108.8,24.6,108.8,25.3z"/><path fill="#D3373C" d="M116.7,23.4L116.7,23.4c0.4-0.7,1.1-1,1.8-1h0.4v1.9c-0.3-0.2-0.5-0.2-0.8-0.2c-1.1,0-1.4,0.7-1.4,1.7v2.3h-2v-5.6h2V23.4z"/><path fill="#D3373C" d="M121.8,22.5v3c0,0.7,0.2,1.2,1,1.2s1-0.5,1-1.2v-3h2v3.4c0,1.9-1.3,2.4-3,2.4c-1.7,0-3-0.6-3-2.4v-3.4H121.8z"/><path fill="#D3373C" d="M129.2,24.5l2.1-2h2.7l-2.8,2.6l3,3h-2.8l-2.2-2.3v2.3h-2V19h2V24.5z"/><path fill="#D3373C" d="M136.8,22.5v3c0,0.7,0.2,1.2,1,1.2s1-0.5,1-1.2v-3h2v3.4c0,1.9-1.3,2.4-3,2.4c-1.7,0-3-0.6-3-2.4v-3.4H136.8z"/></g><g id="Group_12887" transform="translate(155.291 6.697)"><rect id="Rectangle_889" x="0" y="32.3" fill="#D3373C" width="18.4" height="1.7"/><path id="Path_6633" fill="#D3373C" d="M12.6,0H0v22.7h7.2V21H1.7V1.7h9.6V7h5.2v14h-5.5v1.7h7.2V5.6L12.6,0z M13.1,3l2.3,2.3h-2.3V3z"/><path id="Path_6634" fill="#D3373C" d="M8.3,14v14.2l-3.8-3.5L3.3,26l5.8,5.4L15,26l-1.2-1.3l-3.8,3.5V14H8.3z"/></g></svg>';
	markup += '</a>';
	markup += '</div>';
	markup += '<div class="pswp__top-bar">';
	markup += '<div class="nav-buttons">';
	markup += '<span class="gallery-nav__icon close"><span class="font-icon -close pswp__button--close"></span></span>';
	markup += '<span class="gallery-nav__icon share"><span class="font-icon -share pswp__button--share"></span></span>';
	markup += '<span class="gallery-nav__icon fullscreen"><span class="font-icon -full_screen pswp__button--fs"></span></span>';
	markup += '<span class="gallery-nav__icon zoom"><span class="zoom-icon pswp__button--zoom zoom-in"></span></span>';
	markup += '</div>';
	markup += '<span class="gallery-nav__icon pswp__counter"><div class="pswp__counter"></div></span>';
	markup += '<div class="pswp__preloader">';
	markup += '<div class="pswp__preloader__icn">';
	markup += '<div class="pswp__preloader__cut">';
	markup += '<div class="pswp__preloader__donut"></div>';
	markup += '</div>';
	markup += '</div>';
	markup += '</div>';
	markup += '</div>';
	markup += '<div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">';
	markup += '<div class="pswp__share-tooltip"></div>';
	markup += '</div>';
	markup += '<div class="font-icon -arr_lft_alt pswp__arrow pswp__arrow--left"><svg viewbox="0 0 11.227 14.919" class="icon"><use xlink:href="#arrow"></use></svg></div>';
	markup += '<div class="font-icon -arr_rgt_alt pswp__arrow pswp__arrow--right"><svg viewbox="0 0 11.227 14.919" class="icon"><use xlink:href="#arrow"></use></svg></div>';
	markup += '<div class="pswp__caption">';
	markup += '<div class="pswp__caption__center"></div>';
	markup += '</div>';
	markup += '</div>';
	markup += '<div class="pswp__thumbnails-container">';
	markup += '<div class="slick-arrow -prev"><svg viewbox="0 0 11.227 14.919" class="icon"><use xlink:href="#arrow"></use></svg></div>';
	markup += '<div class="pswp__thumbnails"></div>';
	markup += '<div class="slick-arrow -next"><svg viewbox="0 0 11.227 14.919" class="icon"><use xlink:href="#arrow"></use></svg></div>';
	markup += '</div>';
	markup += '<div class="pswp__info main">';
	markup += '<div class="title-text">';
	markup += '<p class="title"></p>';
	markup += '<div class="customCounter" id="counterCustom"></div>';
	markup += '</div>';
	markup += '<div class="info-icon"><span></span></div>';
	markup += '</div>';
	markup += '</div>';
	markup += '</div>';

	$('.pswp').remove();
	$('body').append(markup);
	pswpElement = document.querySelectorAll('.pswp')[0];
	self.getItems();

	// find nearest parent element
    var closest = function closest(el, fn) {
        return el && ( fn(el) ? el : closest(el.parentNode, fn) );
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function(e) {
        e = e || window.event;

        var eTarget = e.target || e.srcElement;

        if ($(eTarget).closest('a').hasClass('item-ps') || $(eTarget).hasClass('item-ps')) {
        	e.preventDefault();
	        // find root element of slide
	    	var clickedListItem = closest(eTarget, function(el) {
	        	return (el.tagName === 'A');
	        });

	        if(!clickedListItem) {
	            return;
	        }

	        // find index of clicked item by looping through all child nodes
	        // alternatively, you may define index via data- attribute
	        var clickedGallery = $(clickedListItem).closest('.gallery-ps'),
	            childNodes = $(clickedListItem).closest('.gallery-ps').find('a.item-ps'),
	            numChildNodes = childNodes.length,
	            nodeIndex = 0,
	            index;

	        for (var i = 0; i < numChildNodes; i++) {
	            if(childNodes[i].nodeType !== 1) { 
	                continue; 
	            }

	            if(childNodes[i] === clickedListItem) {
	                index = nodeIndex;
	                break;
	            }
	            nodeIndex++;
	        }

	        if(index >= 0) {
	            // open PhotoSwipe if valid index found
	            // openPhotoSwipe(pswpElement, false, index, clickedGallery); 
	            // podanie clickedGallery powoduje buga - zdjecia sie nie laduja przy cofaniu strzalkami w otwartej galerii
	            openPhotoSwipe(eTarget, index);
	        }

	        if ($(clickedListItem).hasClass('-product')) {
	        	$('.pswp').find('.download-file-icon').addClass('-hidden');
	        } else {
	        	if ($(e.target).closest('.gallery-ps').attr('data-download') && $(e.target).closest('.gallery-ps').attr('data-download') != '') {
		        	$('.pswp').find('.download-file-icon').find('a').attr('href', clickedListItem.href);
		        	$('.pswp').find('.download-file-icon').removeClass('-hidden');
		        } else {
		        	$('.pswp').find('.download-file-icon').addClass('-hidden');
		        }
	        }

	        return false;
	    }
    };

    var photoswipeParseHash = function() {
        var hash = window.location.hash.substring(1),
        params = {};

        if(hash.length < 5) {
            return params;
        }

        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
            if(!vars[i]) {
                continue;
            }
            var pair = vars[i].split('=');  
            if(pair.length < 2) {
                continue;
            }           
            params[pair[0]] = pair[1];
        }

        if(params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        return params;
    };
	
	var openPhotoSwipe = function (target, index, galleryEl, fromURL) {
		var startIndex, newIndexPs, indexPs, textWidth,
			gallery = $(target).closest('.gallery-ps'),
			slickSlider = $(target).closest('.slick-slider');
			thumbsSlick = slickSlider.siblings('.product-gallery-carousel').length ? slickSlider.siblings('.product-gallery-carousel').find('.slick-slider') : null;

		if (galleryEl)
			gallery = galleryEl;
		if (!target) {
			startIndex = index - 1;
		} else {
			startIndex = $(target).closest("a.item-ps").attr('data-pid');
		}
		
		// $('.pswp__info .title, .gallery-description__title').text(slickSlider.find(".slick-current").find('.slick-title').text());
		// $('.gallery-description-text').html(slickSlider.find(".slick-current").find('.slick-description').html());

		var gid = parseInt($(gallery).attr('data-gid')),
			items = self.items[gid],
			type = parseInt($(gallery).attr('data-thumb') ? $(gallery).attr('data-thumb') : 0),
			options = {
				showHideOpacity: true,
				galleryUID: gid,
				index: parseInt(startIndex),
				closeOnScroll: false,
				captionEl: false,
				fullscreenEl: true,
				barsSize: {top:200, bottom:'auto'},
				getThumbBoundsFn: function(index) {
					var	pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
						thumbnail = self.items[gid][index].el,
						rect = thumbnail.getBoundingClientRect(),
						rectLeft = parseInt(rect.left.toFixed(1)),
						rectTop = parseInt(rect.top.toFixed(1)),
						rectWidth = parseInt(rect.width.toFixed(1));

					return {x:rectLeft, y:rectTop + pageYScroll, w:rectWidth};
				},
				getDoubleTapZoom: function(isMouseClick, item) {
				    // if(!isMouseClick) {
				        return item.initialZoomLevel < 0.7 ? 1 : 1.5;
				    // }
				}
			};
		
		var galleryElement = $(gallery);
		gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
		gallery.init();

		indexPs = gallery.getCurrentIndex();

		// if (isVideo) {
		// 	var currentIframe = $('iframe.pswp__video[data-index="'+indexPs+'"]');
		// 	currentIframe.css('display', 'block');
		// 	currentIframe.parent().siblings('.play-button-wrapper').find('span.play').css('display', 'none');
		// 	currentIframeSrc = currentIframe.attr('src');
		// 	if ($('html').hasClass('no-touch')) {
		// 		currentIframe.attr('src', currentIframeSrc+'?autoplay=1');
		// 	}
		// }

		// var titleSlide = $(galleryElement).find("[data-slick-index='"+indexPs+"']").find('.slick-title').text();
		// var textSlide = galleryElement.find("[data-slick-index='"+indexPs+"']").find('.slick-description').html();
		// $('.pswp__info .title, .gallery-description__title').text(titleSlide);

		// if (textSlide === "") {
		// 	$('.gallery-description-text').html('');
		// 	$('.info-icon span').removeClass('-visible');
		// } else {
		// 	$('.gallery-description-text').html(textSlide);
		// 	$('.info-icon span').addClass('-visible');
		// }

		var topGap = 50;
		var bottomGap = 50;
		var leftGap = 50;
		var rightGap = 50;

		if (galleryElement.attr('data-thumbs') && galleryElement.attr('data-thumbs') != "0") {
			bottomGap = 140;
		}

		gallery.options.barsSize.top = topGap;
		gallery.options.barsSize.bottom = bottomGap;
		gallery.options.barsSize.left = leftGap;
		gallery.options.barsSize.right = rightGap;
		gallery.updateSize(true);
		
		gallery.listen('beforeChange', function() {
			newIndexPs = gallery.getCurrentIndex();
			indexPs = newIndexPs;
			$('.pswp__video').each(function() {
				var src = $(this).attr('src');
				$(this).css('display', 'none');
				if (src && src.match(/\?autoplay=1/g)) {
					var repl = src.replace(/\?autoplay=1/, '');
					$(this).attr('src', repl);
				}
			});
			$('span.play').css('display', 'block');
			
			// $('.pswp__info .title, .gallery-description__title').text(slickSlider.find(".slick-slide[data-slick-index='"+newIndexPs+"']").find('.slick-title').text());
			
		});

		gallery.listen('parseVerticalMargin', function(item) {
			var gap = item.vGap;
			gap.top = topGap;
			gap.bottom = bottomGap;
			gap.left = leftGap;
			gap.right = rightGap;
		});

		gallery.listen('afterChange', function() {
			if ($(target).closest('.slick-slider').length)
				slickSlider.slick('slickGoTo', newIndexPs);
			if ($(target).closest('.slick-slider').siblings('.product-gallery-carousel').length)
				thumbsSlick.slick('slickGoTo', newIndexPs);
			
			//jesli item-ps jest z produktu, to ukrywam button pobierania
			if (galleryElement.find('a.item-ps[data-pid="'+newIndexPs+'"]').hasClass('-product')) {
				$('.pswp').find('.download-file-icon').addClass('-hidden');
			} else {
				if (galleryElement.attr('data-download') && galleryElement.attr('data-download') != '') {
					$('.pswp').find('.download-file-icon').removeClass('-hidden');
				}
			}

			//zmiana linku
			$('.pswp').find('.download-file-icon').find('a').attr('href', gallery.items[newIndexPs].src);

			//klasa active na miniaturkach
			$('.pswp__thumbnails a').removeClass('-active');
			$('.pswp__thumbnails a[data-index="'+(parseInt(newIndexPs))+'"]').addClass('-active');

			//slick w miniaturkach
			if ($('.pswp__thumbnails').hasClass('slick-slider')) {
				$('.pswp__thumbnails').slick('slickGoTo', parseInt(newIndexPs));
			}
		});

		gallery.listen('gettingData', function(index, item) {
			//nothing here
		});
	
		gallery.listen('resize', function() {
			// $('.pswp__video').each(function() {
			// 	var img = $(this).parent('.iframe-wrapper').siblings('.pswp__imag');
			// 	var imgWidth = img.width();
			// 	var imgHeight = img.height();
			// 	$(this).css('width', imgWidth);
			// 	$(this).css('height', imgHeight);
			// });
		});

		gallery.listen('unbindEvents', function() { 
			// slickSlider.slick('slickGoTo', indexPs);
			setTimeout(function() {
				if ($('.pswp--open').length)
					$('.pswp--open').removeClass().addClass('pswp');
			}, 500);
		});

		if(fromURL) {
           	if(gallery.options.galleryPIDs) {
           	    // parse real index when custom PIDs are used 
           	    // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
           	    for(var j = 0; j < items.length; j++) {
           	        if(items[j].pid == index) {
           	            gallery.options.index = j;
           	            break;
           	        }
           	    }
           	} else {
           	    // in URL indexes start from 1
           	    gallery.options.index = parseInt(index, 10) - 1;
           	}
       	} else {
			options.index = parseInt(index, 10);
		}

	    if( isNaN(options.index) ) {
			return;
		} 

		if (!galleryElement.attr('data-thumbs') || galleryElement.attr('data-thumbs') == "0") {
			$('div.pswp__thumbnails-container').addClass('-hidden');
		} else {
			$('.pswp').addClass('-thumbs');
			$('div.pswp__thumbnails').empty().removeClass('slick-initialized').removeClass('slick-slider');

			$.each(items, function(index, item) {
				$('div.pswp__thumbnails').append('<a href="#" data-index="'+parseInt(index)+'"><img src="/img/gallerythumb/100'+item.src+'" alt="">');
			});

		    $('div.pswp__thumbnails a[data-index="'+gallery.getCurrentIndex()+'"]').addClass('-active');

		    $(document).on('click touchstart', 'div.pswp__thumbnails a', function(e) {
		    	e.preventDefault();
		        $('div.pswp__thumbnails a').removeClass("-active");
		        $(this).addClass('-active');
		        gallery.goTo(parseInt($(this).attr('data-index')));
		    });

			app.slick.createThumbnailsCarousel($('.pswp__thumbnails'));
			$('.pswp__thumbnails').slick('slickGoTo', gallery.getCurrentIndex());
		}
	};

	var galleryElements = document.querySelectorAll(gallerySelector);
	// loop through all gallery elements and bind events

	for(var i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i+1);
        galleryElements[i].onclick = onThumbnailsClick;
    }

	var hashData = photoswipeParseHash();

	if(hashData.pid !== undefined && hashData.gid !== undefined) {
		openPhotoSwipe(null, false, hashData.pid, galleryElements[hashData.gid], true);
    }	

  //   $('body').on('click touchstart','.play', function() {
		// var iframe = $(this).parent().siblings().find('iframe');
		// var src = iframe.attr('src');
		// iframe.css('display', 'block');
		// if ($('html').hasClass('no-touch')) {
		// 	iframe.attr('src', src+'?autoplay=1');
		// }
		// $(this).css('display', 'none');

		// $('.pswp__video').each(function() {
		// 	var img = $(this).parent('.iframe-wrapper').siblings('.pswp__imag');
		// 	var imgWidth = img.width();
		// 	var imgHeight = img.height();
		// 	$(this).css('width', imgWidth);
		// 	$(this).css('height', imgHeight);
		// });
  //   });

    // $('body').on('click touchstart', '.pswp__button--close', function() {
    	// $('.pswp__video').remove();
    // });

    $('body').on('click','a.item-ps',function(e) {
		e.preventDefault();
		// var isVideo;
		// var index = $(this).attr('data-pid');
		// var gallery = $(this).closest('.gallery-ps');
		// if ($(this).find('img').attr('data-ytlink') !== "" || $(this).find('img').attr('data-vimeolink') !== "") {
		// 	isVideo = true;
		// } else {
		// 	isVideo = false;
		// }
		// openPhotoSwipe(e.target, isVideo, index, gallery);
		// openPhotoSwipe(e.target, index, gallery);
		// setTimeout(function() {
		// 	$('.pswp__video').each(function() {
		// 		var img = $(this).parent('.iframe-wrapper').siblings('.pswp__imag');
		// 		var imgWidth = img.width();
		// 		var imgHeight = img.height();
		// 		$(this).css('width', imgWidth);
		// 		$(this).css('height', imgHeight);
		// 	});
		// }, 200);
	});

};

initPhotoSwipe.prototype.update = function() {
	this.getItems();
};
